import React, { useEffect, useState } from 'react';
import { combine } from '../../../helpers/styles';
import { usePagination } from '/src/hooks/usePagination';
import * as styles from './pagination.module.scss';
import { IF_RANKING_PROFILE_TYPES } from '../../../utils/constants';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import Text from '../text';

const Pagination = ({
  totalCount,
  resultsPerPage,
  currentPage,
  siblingCount,
}) => {
  const [windowLocation, setWindowLocation] = useState(null);
  useEffect(() => {
    setWindowLocation(location);
  }, []);

  const [query, _] = useQueryParams({
    profileTypes: StringParam,
    continents: StringParam,
    countries: StringParam,
    keywords: NumberParam,
    page: NumberParam,
  });

  const queryFilters = {
    profileTypes:
      query.profileTypes ||
      IF_RANKING_PROFILE_TYPES.DESIGN_AND_ARCHITECTURE_STUDIO,
    continents: query.continents || '',
    countries: query.countries || '',
    keywords: query.keywords || 0,
    page: query.page || 1,
  };
  const totalPages = Math.ceil(totalCount / resultsPerPage);

  const items = usePagination({
    currentPage,
    count: totalPages,
    siblingCount,
  });

  const renderPageLink = (pageNum, text, disabled) => {
    const searchParams = new URLSearchParams(windowLocation?.search);
    searchParams.set('page', pageNum);

    searchParams.sort();

    return (
      <a
        href={`?${searchParams}#resultList`}
        className={combine(
          styles.paginationItem,
          pageNum === queryFilters.page && !text && styles.active,
          disabled && styles.disabled
        )}
      >
        <Text as="span">{text || pageNum}</Text>
      </a>
    );
  };

  return (
    <div className={styles.pagination}>
      {items.map((item) => {
        switch (item.type) {
          case 'start-ellipsis':
          case 'end-ellipsis':
            return (
              <span className={styles.paginationItem} key={item.type}>
                &hellip;
              </span>
            );
          case 'page':
            return !item.disabled && renderPageLink(item.page);
          case 'previous':
            return (
              totalPages > 1 &&
              renderPageLink(queryFilters.page - 1, '<', item.disabled)
            );
          case 'next':
            return (
              totalPages > 1 &&
              renderPageLink(queryFilters.page + 1, '>', item.disabled)
            );
        }
      })}
    </div>
  );
};

export default Pagination;
